import { FC, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getDaysInMS } from "@jurijtokarski/times";

import "./Install.css";

import { IconButton } from "./IconButton";
import { isIOS, isInStandaloneMode, getNextCheckTimestamp, setNextCheckTimestamp } from "../utils/ui";
import { useStorage } from "../utils/useStorage";
import { IOSInstall } from "./IOSInstall";
import { CloseIcon, DownloadIcon } from "./Icons";

export const Install: FC = () => {
  const [isInstallBarVisible, setInstallBarVisible] = useState(false);
  const [isIOSInstallWindowVisible, setIOSInstallWindowVisible] = useState(false);

  const { todayProgress } = useStorage();

  const nextCheck = getNextCheckTimestamp();
  const isStandalone = isInStandaloneMode();
  const isIOSDevice = isIOS();

  useEffect(() => {
    if (!isIOSDevice) {
      return;
    }

    if (isStandalone) {
      return;
    }

    if (nextCheck && nextCheck > Date.now()) {
      return;
    }

    if (!todayProgress) {
      return;
    }

    setTimeout(() => setInstallBarVisible(true), 1000);
  }, [todayProgress, isIOSDevice, nextCheck, isStandalone]);

  const handleIOSCloseClick = () => {
    setIOSInstallWindowVisible(false);
    setTimeout(() => setInstallBarVisible(true), 400);
  };

  const handleInstallClick = () => {
    setInstallBarVisible(false);
    setIOSInstallWindowVisible(true);
  }

  const handleCloseClick = () => {
    setInstallBarVisible(false);
    setNextCheckTimestamp(Date.now() + getDaysInMS(7));
  }

  return (
    <>
      <motion.div
        className="install"
        initial={{
          y: 100,
          opacity: 0
        }}
        animate={{
          y: isInstallBarVisible ? 0 : 100,
          opacity: isInstallBarVisible ? 1 : 0,
        }}
        transition={{
          duration: 0.7,
          ease: [0.19, 1, 0.22, 1]
        }}
      >
        <div className="install__wrapper">
          <span className="install__label">
            <button className="install__button" onClick={handleInstallClick}>
              <DownloadIcon /> Install
            </button> and track drinks offline
          </span>
          <IconButton className="install__close" onClick={handleCloseClick}>
            <CloseIcon />
          </IconButton>
        </div>
      </motion.div>
      <IOSInstall isVisible={isIOSInstallWindowVisible} onClose={handleIOSCloseClick} />
    </>
  );
}